<template>
  <div class="button-list" :class="{ open: state }">
    <div
      class="icon h-100"
      style="height: 29px"
      v-tooltip="{ content: tooltip }"
    >
      <div
        class="icon-bg align-center-div otz-icon icon-circle center-y center"
        @click.stop="toggleList()"
      >
        <div v-if="oneArrow">
          <div class="otz-icon">q</div>
        </div>
        <div v-else>
          <div class="otz-icon arrow-1">q</div>
          <div class="otz-icon arrow-2">q</div>
        </div>
      </div>
      <span>{{ text }}</span>
    </div>
    <div v-if="state" v-click-outside="closeList" class="list drop">
      <div class="header-list">
        <span class="title">
          <slot name="header"></slot>
        </span>
        <div class="icon">
          <BaseIconX
            v-show="getshowCloseIcon"
            :nameIcon="nameIconRemove"
            @click="toggleList"
          />
        </div>
      </div>
      <div class="list-content">
        <slot name="listContent" :toggleList="toggleList"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    nameIconOpenList: {
      type: String,
      default: "",
    },
    nameIconClosedList: {
      type: String,
      default: "",
    },
    showCloseIcon: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    oneArrow: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: "",
    },
    openList: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    openList: function (val) {
      this.toggleList();
    },
    closeListFromOutside: function () {
      this.closeList();
    },
  },
  data() {
    return {
      state: false,
      nameIconOpen: this.nameIconOpenList,
      nameIconClosed: this.nameIconClosedList,
      listItems: null,
      //showCloseIcon: false,
      nameIconRemove: "x-list",
    };
  },
  computed: {
    ...mapState("tabsManager", ["closeListFromOutside"]),
    getIconName() {
      return this.state ? this.nameIconTrue : this.nameIconFalse;
    },
    getshowCloseIcon() {
      return this.showCloseIcon ? this.showCloseIcon : false;
    },
  },
  methods: {
    toggleList() {
      this.state = !this.state;

      if (!this.state) this.$emit("closed");
      else this.$emit("open");
    },
    closeList() {
      this.state = false;
      this.$emit("closed");
    },
    parentList() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.button-list {
  .icon {
    // height: 100%;
  }
  .list-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: column;
    &.left {
      left: 0;
    }
  }
  .list {
    z-index: 4;
  }
}
.arrow-1,
.arrow-2 {
  transform: rotate(90deg);
  position: absolute;
  top: 0;
  left: -3px;
  font-size: 23px;
  background-color: transparent !important;
}
.arrow-1 {
  left: 2px;
}
</style>
